import { render, staticRenderFns } from "./FreshReceptionWeightComparison.vue?vue&type=template&id=c8454c02&scoped=true"
import script from "./FreshReceptionWeightComparison.vue?vue&type=script&lang=js"
export * from "./FreshReceptionWeightComparison.vue?vue&type=script&lang=js"
import style0 from "./FreshReceptionWeightComparison.vue?vue&type=style&index=0&id=c8454c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8454c02",
  null
  
)

export default component.exports